module.exports = __webpack_public_path__ + "static/media/kizuna-result-1.83cfaf37.png";